module.exports = __webpack_public_path__ + "img/yahoo.7820f354.svg";